// extracted by mini-css-extract-plugin
var _1 = "bpltdOEu9zJNYpcqLvy7";
var _2 = "rZgq4IlN8LWirbCe9TMW";
export { _1 as "legend", _2 as "root" }
